export const mainTheme = {
  primary: "#00003C",
  secondary: "#E3E3E3",
  details: "#E60019",
};
